import { Calendar, momentLocalizer } from "react-big-calendar";
import { Card, Button, Space, Form, Drawer, Select, DatePicker } from "antd";
import { useMemo, useState, useRef, useEffect } from "react";
import moment from "moment";
import "./Medicaid.scss";
import classNames from "classnames";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import CustomToolBar from "./CustomToolBar";
import MedicaidAgenda from "./MedicaidAgenda";
import {useMeetingsHook, useFiltersHook} from "./CustomHooks";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const localizer = momentLocalizer(moment);

const Medicaid = () => {
  console.log('component re rendered')
  const [date, setDate] = useState(new Date());
  const [defaultView, setDefaultView] = useState("month");
  const [view, setView] = useState(defaultView);
  const [currentDate, setCurrentDate] = useState(moment().startOf("day"));
  const [filterFlag, setFilterFlag] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [medMeetingData, setMeetings] = useState([]);
  const [meetingFilters, setMeetingFilters] = useState({
    drugClasses: [],
    meetingType: [],
    states: [],
    view: "month",
    year: [],
    meetingStatus: [],
    agendaStatus: [],
    therapyClass: [],
    isFilterApplied: false
  });
const [defaultFilters, setDefaultFilters] = useState({
  meetingType: [],
  states: [],
  drugClasses: [],
  year: [],
  therapyClass: [],
  agendaStatus: [],
  meetingStatus: [],
});
  const currentDateRef = useRef();
  const navigate = useNavigate();
  currentDateRef.current = currentDate || new Date();
  const currentView = useRef();
  currentView.current = defaultView;

  const windowSize$ = useSharedState();
  const [form] = Form.useForm();

  //----Custom Hook To Fetch Filters ---- //
  const fetchFilters = useFiltersHook();
  const {
    agendaStatuses,
    drugClasses,
    meetingTypes,
    meetingStatuses,
    therapyClasses,
    states
  } = fetchFilters;

   //----Custom Hook To Fetch Medicaid Confernces & Default Filters ---- //
  const {meetings, filtersData} = useMeetingsHook(meetingFilters, view);

  useEffect(() => {
    if(filtersData) {
      setDefaultFilters(filtersData)
    }
  } , [filtersData])

  //------- Function to apply filters for medicaid meetings ---------//
  const applyMeetingFilters = () => {
    const filters = form.getFieldsValue(true);
    setMeetingFilters((prev) => ({
      ...prev,
      meetingType: filters?.meetingType ? filters?.meetingType : [],
      states: filters?.states ? filters?.states : [],
      drugClasses: filters?.drugClasses ? filters?.drugClasses : [],
      therapyClass: filters?.therapyClass ? filters?.therapyClass : [],
      agendaStatus: filters?.agendaStatus ? filters?.agendaStatus : [],
      meetingStatus: filters?.meetingStatus ? filters?.meetingStatus : [],
      isFilterApplied: true
    }));
    setFilterFlag(false);
  };

  const resetFilters = () => {
    form.resetFields();
    setMeetingFilters((prev) => ({
      ...filtersData,
      isFilterApplied: false
    }));
  }

  const hanldeViewChange = (newView) => {
    setDefaultView(newView);
    setView(newView);
    setMeetingFilters((prev) => ({
      ...prev,
      view: newView,
    }));
  };

  const handleNavigate = (action, date) => {
    if (action === "TODAY") {
      setCurrentDate(moment().startOf("day"));
    } else if (action === "DATE") {
      setCurrentDate(new Date(date));
    } else if (action === "PREV") {
      setCurrentDate((prevDate) =>
        moment(prevDate).subtract(1, currentView.current).toDate()
      );
    } else if (action === "NEXT") {
      setCurrentDate((prevDate) =>
        moment(prevDate).add(1, currentView.current).toDate()
      );
    }
  };

  const openFilterDrawer = () => {
    setFilterFlag(true);
  };

  const onCloseFilter = () => {
    form.resetFields();
    form.setFieldsValue(filtersData);
    setFilterFlag(false);
  };

  const components = useMemo(
    () => ({
      toolbar: (props) => (
        <CustomToolBar
          handleNavigate={handleNavigate}
          updateView={hanldeViewChange}
          openFilterDrawer={openFilterDrawer}
          view={view}
          defaultView={currentView.current}
          currentDate={currentDateRef}
          {...props}
        />
      ),
    }),
    []
  );

  const columns = [
    {
      label: "Medicaid",
      link: "",
    },
  ];

  const eventPropsHandler = (event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: event.color,
        border: "none",
        padding: "2px 6px",
        boxShadow: "none",
      },
    };
  };

  const onDrillDown = (e) => {
    console.log(e, "event fored on drill down");
  };

  const onSelectEvent = (e) => {
    navigate(`/medicaid/meetingDetails/${e.id}`, {
       state: {
      filters: meetingFilters
    }
    })
    console.log(e, "event fired on select event");
  };

  const onShowMore = (moreEvents, date) => {
    console.log(moreEvents, "event fired on show more");
    console.log(date, "event fired on show more");
  };

  const handleCalender = (event, value, key) => {
    setFilterDate(value);
  };


  const handleEvents = (data) => {
  setMeetingFilters((prev) => ({
    ...prev,
    year: data.years,
    isFilterApplied: true
  }));
};

  return (
    <div className="details-root" data-test="details-container">
      {filterFlag && (
        <Drawer
          title="Enter filter details"
          size="default"
          onClose={onCloseFilter}
          open={filterFlag}
          styles={{
            body: {
              paddingBottom: 80,
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingTop: "0px",
            },
          }}
          footer={
            <Space>
              <Button
                style={{ background: "#000000" }}
                type="primary"
                onClick={applyMeetingFilters}
              >
                Apply
              </Button>
              <Button onClick={onCloseFilter}>Cancel</Button>
              <Button onClick={resetFilters}>Reset</Button>
            </Space>
          }
        >
          <Form form={form} layout="vertical" hideRequiredMark>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                States
              </label>
              <Form.Item name="states">
                <Select
                  mode="multiple"
                  defaultValue={defaultFilters?.states}
                  options={states}
                  placeholder="Select drug classes"
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "5px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Drug Classes
              </label>
              <Form.Item name="drugClasses">
                <Select
                  placeholder="Select Drug Classes"
                  mode="multiple"
                  defaultValue={defaultFilters?.drugClasses}
                  options={drugClasses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
             <div className="form-item-mail" style={{ marginBottom: "5px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Therapy Classes
              </label>
              <Form.Item name="therapyClass">
                <Select
                  placeholder="Select Drug Classes"
                  mode="multiple"
                  defaultValue={defaultFilters?.therapyClass}
                  options={therapyClasses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Meeting Type
              </label>
              <Form.Item name="meetingType">
                <Select
                  placeholder="Select Meeting"
                  mode="multiple"
                  defaultValue={defaultFilters?.meetingType}
                  options={meetingTypes}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Meeting Status
              </label>
              <Form.Item name="meetingStatus">
                <Select
                  placeholder="Select Meeting Status"
                  mode="multiple"
                  defaultValue={defaultFilters?.meetingStatus}
                  options={meetingStatuses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Agenda Status
              </label>
              <Form.Item name="agendaStatus">
                <Select
                  placeholder="Select Meeting Status"
                  mode="multiple"
                  defaultValue={defaultFilters?.agendaStatus}
                  options={agendaStatuses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
          </Form>
        </Drawer>
      )}
      <div className="container">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>

        <Card>
          <div
            className={classNames("calendar-height calender-big", {
              "margin-classs":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "margin-class":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            {view && view === "month" && (
              <Calendar
                localizer={localizer}
                defaultView={defaultView}
                events={meetings}
                startAccessor="start"
                endAccessor="end"
                // date={date}
                value={currentDate}
                date={currentDate}
                view={view}
                onNavigate={setDate}
                onView={setView}
                components={components}
                eventPropGetter={eventPropsHandler}
                drilldownView="null"
                onDrillDown={onDrillDown}
                onSelectEvent={onSelectEvent}
                popup
              />
            )}
            {view && view === "agenda" && (
              <MedicaidAgenda
                events={meetings}
                updateView={hanldeViewChange}
                currentDate={currentDateRef}
                view={view}
                handleEvents={handleEvents}
                // startDate={meetingFilters.start}
                // endDate={meetingFilters.end}
                agendaFilter={filtersData}
                year={meetingFilters.year}
              />
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Medicaid;
